import { FormSelectYesNo } from '../../formelements'

export const AuthDretsImatge = ({ auth, handleChange, error, enguany, anyVinent }) => {

  return (<>
                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                       Drets d’imatge. Curs {enguany}-{anyVinent}
                                    </h4>
                                    <p>
                                      AUTORITZO que la imatge del meu fill/a, pugui aparèixer en fotografies, vídeos, pàgines web i altres mitjans, corresponents a activitats escolars lectives, complementàries i extraescolars, de l’Institut i/o l’AMPA.
                                    </p>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col col-12 ">
                                    <FormSelectYesNo
                                      id="authDretsImatge"
                                      name="authDretsImatge"
                                      col="col-4"
                                      label="Drets d'Imatge:"
                                      obligatori={true}
                                      value={auth}
                                      handleChange={(e) => handleChange(e.target.value) }
                                      error={error}
                                    />
                                </div>
                               </div>
  </>)
}
